<template>
  <AppDialog
    class="integration-wizard-projects-confirm-sync-dialog"
    :show="show"
    :title="title"
    append-to-body
    @close="close"
  >
    <div class="d-flex flex-column align-items-start justify-content-between">
      <div>This will sync the following {{ integrationDisplayName }} {{ $filters.pluralize(2, projectLabel) }}.</div>
      <div class="projects-list-wrapper d-flex justify-content-between mt-20">
        <div class="projects-list-container d-flex flex-column">
          <div class="projects-list-header">
            <img
              :src="ICON_PLUS"
              alt="New project icon"
              width="10"
              height="10"
            />
            Create new Hubstaff projects
          </div>
          <template v-if="viewableCreateProjects.length > 0">
            <div
              v-for="(project, index) in viewableCreateProjects"
              :key="index"
              class="d-flex flex-column align-self-start"
            >
              {{ index + 1 }}. {{ projectName(project) }}
            </div>
            <div
              v-if="hiddenCreateProjects.length > 0"
              v-popover="{ html: true, placement: 'auto left' }"
              data-tipclass="more-projects-popover"
              :data-content="getProjectsPopover(hiddenCreateProjects)"
            >
              <span class="text-blue"> and {{ hiddenCreateProjects.length }} more </span>
            </div>
          </template>
          <template v-else> No new projects to create. </template>
        </div>
        <div class="projects-list-container d-flex flex-column">
          <div class="projects-list-header">
            <img
              :src="ICON_CONNECT"
              alt="New project icon"
              width="10"
              height="10"
            />
            Sync with existing Hubstaff projects
          </div>
          <template v-if="viewableMatchedProjects.length > 0">
            <div
              v-for="(project, index) in viewableMatchedProjects"
              :key="index"
              class="d-flex flex-column align-self-start"
            >
              {{ index + 1 }}. {{ projectName(project) }}
            </div>
            <div
              v-if="hiddenMatchedProjects.length > 0"
              v-popover="{ html: true, placement: 'auto right' }"
              data-tipclass="more-projects-popover"
              :data-content="getProjectsPopover(hiddenMatchedProjects)"
            >
              <span class="text-blue"> and {{ hiddenMatchedProjects.length }} more </span>
            </div>
          </template>
          <template v-else> No matched {{ $filters.pluralize(2, projectLabel) }}. </template>
        </div>
      </div>
    </div>
    <template #footer>
      <AppButton @click="close">Cancel</AppButton>
      <AppButton
        type="primary"
        :disabled="processRequest"
        @click="save"
      >
        Confirm
      </AppButton>
    </template>
  </AppDialog>
</template>

<script>
import createPersist from '../../utils/persist';
import { ICON_PLUS, ICON_CONNECT } from '~/rails_assets';

const localStore = createPersist('integration-wizard');

export default {
  name: 'IntegrationWizardConfirmProjectsSyncDialog',
  props: {
    show: Boolean,
    title: String,
    processRequest: Boolean,
    createProjects: Array,
    matchedProjects: Array,
  },
  data() {
    const store = localStore.get('integrationWizardState');

    return {
      ICON_PLUS,
      ICON_CONNECT,
      saving: false,
      integrationDisplayName: store.integration_display_name,
      projectLabel: store.labels.project,
    };
  },
  computed: {
    viewableCreateProjects() {
      return this.createProjects.slice(0, 4);
    },
    hiddenCreateProjects() {
      if (this.createProjects.length >= 5) {
        return this.createProjects.slice(4);
      }

      return [];
    },
    viewableMatchedProjects() {
      return this.matchedProjects.slice(0, 4);
    },
    hiddenMatchedProjects() {
      if (this.matchedProjects.length >= 5) {
        return this.matchedProjects.slice(4);
      }

      return [];
    },
    hasSidebarClass() {
      return this.showSidebar && !this.isMobile ? 'has-sidebar-on' : '';
    },
  },
  methods: {
    projectName(project) {
      return project.normalized_name ? project.normalized_name : project.remote_name;
    },
    save() {
      this.saving = true;
      this.$emit('confirm');
    },
    close() {
      this.$emit('close');
    },
    getProjectsPopover(projects) {
      if (projects.length === 0) {
        return null;
      }
      const $wrap = $('<div></div>');

      projects.forEach((project, index) => {
        $wrap.append(
          $('<div/>')
            .addClass('popover-item')
            .text(`${index + 5}. ${this.projectName(project)}`),
        );
      });

      return $wrap.html();
    },
  },
};
</script>
